import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResourceTable = _resolveComponent("ResourceTable")!

  return (_openBlock(), _createBlock(_component_ResourceTable, {
    schema: $props.schema,
    rows: $options.filteredRows,
    headers: $options.headers,
    loading: $props.loading,
    "use-query-params-for-simple-filtering": $props.useQueryParamsForSimpleFiltering
  }, null, 8, ["schema", "rows", "headers", "loading", "use-query-params-for-simple-filtering"]))
}